import {useState} from "react";
import {useStore} from "hooks/useStore";

// Alt firmanın aktif sözleşme detayını tek modal örneği üzerinden açmak için paylaşılan hook.
// Alt firma ücretlendirme listesi ve alt firma detay ekranı gibi birden fazla sayfa tarafından kullanılır.
export const useActiveContractDetail = () => {
    const stores = useStore();
    const [loadingSubCompanyId, setLoadingSubCompanyId] = useState(null);
    const [contract, setContract] = useState(null);

    const open = async subCompanyId => {
        setLoadingSubCompanyId(subCompanyId);
        const result = await stores.companyStore.getSubCompanyPaymentContracts({subCompanyId});
        setLoadingSubCompanyId(null);

        if (result?.activeContract) {
            setContract(result.activeContract);
        }
    };

    const close = () => setContract(null);

    return {loadingSubCompanyId, contract, open, close};
};
